import prismicDOM from 'prismic-dom'

const Elements = prismicDOM.RichText.Elements

export default function (type, element, content, children) {
  switch (type) {
    case Elements.list:
      return `<ul>${children.join('')}</ul>`

    case Elements.oList:
      return `<ol>${children.join('')}</ol>`
    default:
      return null
  }
}
